import type { ReactNode } from 'react'

import { ChevronRightIcon } from '@gto/icons-react/outline/chevron-right'
import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

import { InlineHighlightedText } from '../inline-highlighted-text'
import type { ModalBlockAlign } from './modal-block-types'

type ModalBulletsBlockProps = {
  items: readonly ReactNode[]
  centerOnMobile?: boolean
  align?: ModalBlockAlign
}

export const ModalBulletsBlock = ({ items, align, centerOnMobile }: ModalBulletsBlockProps) => (
  <ul
    className={cn(
      'flex w-full flex-col gap-2',
      align === 'left' && 'items-start text-left',
      align === 'center' && 'items-center text-center',
      centerOnMobile === true && 'sm:items-center sm:text-center',
    )}
  >
    {items.map((item, index) => (
      <Typography
        // eslint-disable-next-line @eslint-react/no-array-index-key -- ordered API copy has no stable item id
        key={index}
        className="flex items-start gap-2"
        color="text.secondary"
        component="li"
        variant="body1"
      >
        <ChevronRightIcon className="mt-1 size-3 shrink-0 text-primary-main" />
        <span className="min-w-0 whitespace-pre-line [overflow-wrap:anywhere]">
          {typeof item === 'string' ? <InlineHighlightedText text={item} /> : item}
        </span>
      </Typography>
    ))}
  </ul>
)
